module.exports = __webpack_public_path__ + "static/media/shopping-bag-2.cf3fcab6.svg";